import { render, staticRenderFns } from "./ModalFormularioPagoUniversidadAgrupados.vue?vue&type=template&id=63f2438d&scoped=true"
import script from "./ModalFormularioPagoUniversidadAgrupados.vue?vue&type=script&lang=js"
export * from "./ModalFormularioPagoUniversidadAgrupados.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioPagoUniversidadAgrupados.vue?vue&type=style&index=0&id=63f2438d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f2438d",
  null
  
)

export default component.exports